
import { Component, Vue, Watch } from 'vue-property-decorator';
import ImagesUpload from '@/components/ImagesUploadIOS/images-upload.vue';
import TextNotice from '@/views/ios/componets/TextNotice.vue';
import { PublicQuery } from '@/mixins/public_query';
import { adAddEdit, getAdList } from '@/api/exchange-code';
import { iImagesList, eInputType, iAdparams } from '@/interface/exchange-code';
import { eOptionType } from '@/interface/eCommand';
import { toast } from '@/utils/common';
import { eEndPoint } from '@/interface/hot-game';
@Component({
  components: { ImagesUpload, TextNotice },
})
export default class AdsenseNotice extends Vue {
  publicQuery = new PublicQuery();
  defaultuploadSizeType = '1080*582 png,jpg';
  maxW: Number = 1080;
  maxH: Number = 582;
  androidType: eEndPoint = eEndPoint.ADNROID;
  iosType: eEndPoint = eEndPoint.IOS;
  openTypeList: any = [
    {
      label: '跳转链接',
      value: 'link',
    },
    {
      label: '打开游戏',
      value: 'game',
    },
  ];
  gameList: any = [];
  extend: any = {
    game_id: -1,
  };
  isDelete?: boolean = true;
  publicModel: iImagesList = {
    id: '',
    position: '1',
    positionValue: '0', // 位置值
    imageUrl: '',
    uploadText: '添加图片',
    isClass: true,
    uploadSizeType: this.defaultuploadSizeType,
    extend: this.extend,
    fillText: [
      {
        title: '类型',
        value: 'game',
        placeholder: '',
        type: eInputType.RADIO,
        childrens: this.openTypeList,
      },
      { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT, isRelevance: true }, //isRelevance s是否有关联
      {
        title: '',
        value: -1,
        placeholder: '请输入关键字搜索',
        type: eInputType.SELECT,
        isRelevance: true,
        childrens: this.gameList,
        filterable: true,
      },
      { title: '按钮名称', value: '启动游戏', placeholder: '请输入启动按钮名称,不能超过5个', type: eInputType.INPUT, isRelevance: false, max: 5 },
    ],
  };
  idx_img: string = 'idx_img';
  idx_word: string = 'idx_word';
  all_idx = 'idx_img,idx_word';
  app_id = 'android_client';
  imagesList: iImagesList[] = [];
  textImage: iImagesList[] = [];
  publicTextModel: iImagesList = {
    id: '',
    position: '1',
    positionValue: '0', // 位置值
    imageUrl: '',
    isClass: true,
    extend: this.extend,
    fillText: [
      {
        title: '公告文字',
        value: '',
        placeholder: '请输入标题，不超过48个字',
        type: eInputType.INPUT,
        isRelevance: false,
        max: 48,
      },
      {
        title: '类型',
        value: 'game',
        placeholder: '',
        type: eInputType.RADIO,
        childrens: this.openTypeList,
      },
      { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT, isRelevance: true }, //isRelevance s是否有关联
      {
        title: '',
        value: -1,
        placeholder: '请输入关键字搜索',
        type: eInputType.SELECT,
        isRelevance: true,
        childrens: this.gameList,
        filterable: true,
      },
    ],
  };
  paramsImages: iAdparams = {
    app_id: this.app_id,
    advs: [
      {
        idx: '',
        idx_name: '',
        pos: '',
        pos_name: '',
        img: '',
        main_title: '',
        sub_title: '',
        link: '',
        extend: '',
        op_type: '',
      },
    ],
  };
  loading: boolean = false;
  endpoint: number = 0;
  /* 验证 */
  rules() {
    let falg = true;
    this.paramsImages.advs = [];
    let selectValue: number = -1;
    let count = 0;
    for (let item of this.imagesList) {
      selectValue = parseInt(item.fillText![2].value);
      if (!item.imageUrl) {
        this.$message.error('图片位--' + item.position + '位置图片未上传');
        falg = false;
        return falg;
      } else if (item.fillText![0].value == eOptionType.GAME) {
        if (selectValue <= 0) {
          this.$message.error('图片位--' + item.position + '游戏类型未选择');
          falg = false;
          return falg;
        }
      }
      this.paramsImages.advs.push({
        idx: this.idx_img,
        idx_name: '图片位',
        pos: JSON.stringify(count),
        pos_name: JSON.stringify(count + 1),
        img: item.imageUrl,
        main_title: '',
        link: item.fillText![1].value,
        op_type: item.fillText![0].value /* 类型 */,
        extend:
          item.fillText![0].value == 'game'
            ? JSON.stringify({
                game_id: selectValue,
                banner_bottom: item.fillText![3].value,
              })
            : '',
      });
      count++;
    }
    for (let i = 0; i < this.textImage.length; i++) {
      const textItem = this.textImage[i];
      const value = textItem.fillText![0].value;
      const typeValue = textItem.fillText![1].value; //类型
      const linkValue = textItem.fillText![2].value; //连接
      const gameId = textItem.fillText![3].value; //游戏ID

      let pos = (i + 1).toString();
      if (value.trim() == '') {
        this.$message.error('文字位' + pos + '--内容未填写');
        falg = false;
        return falg;
      }
      if (value.length > 48) {
        this.$message.error('文字位' + pos + '--内容不能超过48个字');
        falg = false;
        return falg;
      }

      this.paramsImages.advs.push({
        idx: this.idx_word,
        idx_name: '公告',
        pos: pos,
        pos_name: pos,
        main_title: value,
        img: '',
        link: linkValue,
        op_type: typeValue /* 类型 */,
        extend:
          typeValue == 'game'
            ? JSON.stringify({
                game_id: gameId,
              })
            : '',
      });
      count++;
    }

    return falg;
  }

  async submitSave() {
    const falg = await this.rules();
    if (falg && this.paramsImages && this.paramsImages.advs.length > 0) {
      this.$msgbox({
        title: '提示',
        message: '请仔细检查配置内容及跳转链接，确认生效后，将立即生效。',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            await this.saveAd(this.paramsImages);
            done();
            instance.confirmButtonLoading = false;
            this.loading = false;
          } else if (action === 'cancel') {
            done();
            instance.confirmButtonLoading = false;
            this.loading = false;
          }
        },
      }).then(() => {
        // done();
      });
    }
  }
  /* 新增、修改 */
  async saveAd(params: iAdparams) {
    try {
      const res = await adAddEdit(params);
      if (res && res.code === 0) {
        //
        this.$message.success('保存成功');
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* 赋值 */
  async getList() {
    try {
      const res = await getAdList({ app_id: this.app_id, idx: this.all_idx });
      if (res && res.code == 0) {
        for (let item of res.data) {
          if (item.idx === this.idx_img) {
            const eLen: number = item.advs.length;
            const sLen: number = this.imagesList.length;
            if (sLen < eLen) {
              this.addImageText(sLen, eLen);
            }

            for (let key of item.advs) {
              try {
                const { pos, img, op_type, link, extend } = key;
                this.imagesList[pos].fillText![0].value = op_type;
                this.imagesList[pos].fillText![1].value = link;
                this.imagesList[pos].imageUrl = img;
                /* 得到扩展项目 */
                const extentItem: any = extend == '' ? '' : JSON.parse(extend);
                if (extentItem) {
                  this.imagesList[pos].fillText![2].value = extentItem.game_id; /* 扩展的游戏id */
                }
              } catch (err) {
                console.log(err);
              }
            }
          }
          if (item.idx === this.idx_word) {
            let oldLength = this.textImage.length;
            let newLength = item.advs.length;
            for (let i = oldLength; i < newLength; i++) {
              this.addTextList();
            }
            for (let i = 0; i < newLength; i++) {
              const { pos, op_type, link, extend, main_title } = item.advs[i];

              for (let key of item.advs) {
                this.textImage[i].fillText![0].value = main_title;
                this.textImage[i].fillText![1].value = op_type == '' ? 'game' : op_type;
                this.textImage[i].fillText![2].value = link;
                const extentItem: any = extend == '' ? '' : JSON.parse(extend);
                if (extend != '') {
                  this.textImage[i].fillText![3].value = extentItem.game_id; /* 扩展的游戏id */
                }
              }
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* 游戏类别 */
  async getGameList() {
    const res: any = await this.publicQuery.getGameList();
    if (res) {
      this.gameList = res;
      this.publicModel.fillText![2].childrens = this.gameList;
      this.publicTextModel.fillText![3].childrens = this.gameList;
    }
  }
  /*动态添加图为 默认图位只有一个，其余的动态生成 */
  addImageText(starIndex: number, endIndex: number) {
    if (starIndex < endIndex) {
      for (let i = starIndex + 1; i <= endIndex; i++) {
        this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
      }
    } else {
      this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
    }
  }
  async setValue() {
    await this.getGameList();
    this.publicModel.uploadSizeType = this.defaultuploadSizeType;
    this.addImageText(1, 1);
    this.textImage.push(JSON.parse(JSON.stringify(this.publicTextModel)));
    this.getList();
  }
  /* 新增banner图位 */
  addimagesList() {
    const num: number = this.imagesList.length;
    if (num >= 5) {
      toast('您最多只能添加5个banner', 'error');
      return;
    }

    this.publicModel.position = JSON.stringify(num + 1);
    this.publicModel.positionValue = JSON.stringify(num);
    this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
  }
  //新增文字位
  addTextList() {
    this.textImage.push(JSON.parse(JSON.stringify(this.publicTextModel)));
  }
  //删除文字位
  deleteText(index: number) {
    console.log(index);

    this.textImage.splice(index, 1);
  }
  setParm() {
    //ios
    this.idx_img = 'idx_img';
    this.idx_word = 'idx_word';
    this.all_idx = 'idx_img,idx_word';
    this.app_id = 'ios_client';
    this.defaultuploadSizeType = '1080*582 png,jpg';
    this.maxW = 1080;
    this.maxH = 582;
    this.imagesList = [];
    this.textImage = [];
    this.paramsImages.app_id = this.app_id;
    this.setValue();
  }
  mounted() {
    this.setParm();
  }

  // @Watch('$route.meta.type')
  // onChangeValue(newVal: number, oldVal: number) {
  //   if (newVal != oldVal) {
  //     this.route_type = newVal;
  //     this.setParm();
  //   }
  // }
}
